import { C, font } from "../tokens";

export default function SectionPill({ children, style = {} }) {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        background: C.accentLight,
        border: `1.5px solid ${C.accentBorder}`,
        borderRadius: 24,
        padding: "5px 14px",
        marginBottom: 18,
        fontSize: 12,
        fontWeight: 700,
        color: C.accent,
        letterSpacing: 0.2,
        fontFamily: font,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
